// extracted by mini-css-extract-plugin
export default {"formGroup":"Input_formGroup__omRgr","errorInput":"Input_errorInput__Bna12"};